<template>
  <form
    action=""
    method="POST"
    @submit.prevent="onSubmit"
    @keydown="form.errors.clear($event.target.name)"
    enctype="multipart/form-data"
    class="max-w-3xl mx-auto"
  >
    <v-card class="mb-2">
      <v-card-body>
        <div class="mb-2">
          <v-label>Nume </v-label>
          <v-input type="text" v-model="form.name"></v-input>
          <v-error :error="form.errors.get('name')"></v-error>
        </div>
        <div class="mb-2">
          <v-label>Valoare </v-label>
          <v-input type="number" v-model="form.value"></v-input>
          <v-error :error="form.errors.get('value')"></v-error>
        </div>
        <div class="mb-2">
          <v-label>Tip </v-label>
          <select-fee-type
              v-model="form.type_id"
              selectId="type_id"
              class="mb-2 w-full"
            />
          <v-error :error="form.errors.get('type_id')"></v-error>
        </div>
        <div class="mb-2">
          <v-label>Aplicabilitate </v-label>
          <select-fee-applicability
              v-model="form.applicability_id"
              selectId="applicability_id"
              class="mb-2 w-full"
            />
          <v-error :error="form.errors.get('applicability_id')"></v-error>
        </div>
      </v-card-body>
      <v-card-footer class="text-right">
        <v-button :disabled="form.loading">
          <v-button-icon v-if="form.loading">
            <loader :radius="5" />
          </v-button-icon>
          Salveaza
        </v-button>
      </v-card-footer>
    </v-card>
  </form>
</template>
<script>
import feesApi from "@/api/resources/feesApi";
import Form from "@/core/Form";
import VButton from "@/components/ui/VButton.vue";
import VCard from "@/components/ui/VCard.vue";
import VInput from "@/components/ui/VInput.vue";
import VLabel from "@/components/ui/VLabel.vue";
import VError from "@/components/ui/VError.vue";
import VCardBody from "@/components/ui/VCardBody.vue";
import VCardFooter from "@/components/ui/VCardFooter.vue";
import VButtonIcon from "@/components/ui/VButtonIcon.vue";
import Loader from "@/components/Loader.vue";
import SelectFeeApplicability from './shared/SelectFeeApplicability.vue';
import SelectFeeType from './shared/SelectFeeType.vue';

export default {
  components: {
    VCard,
    VLabel,
    VInput,
    VButton,
    VError,
    VCardBody,
    VCardFooter,
    VButtonIcon,
    Loader,
    SelectFeeApplicability,
    SelectFeeType,
  },

  props: {
    vendorId: { type: String },
  },

  emits: ["fee:created"],

  data() {
    return {
      form: new Form({
        name: "",
        value: "",
        type_id: "",
        applicability_id: "",
      }),
      loading: false,
    };
  },

  methods: {
    onSubmit() {
      this.loading = true;
      this.form
        .submitService(feesApi, "store")
        .then((response) => {
          this.$emit("fee:created", response.data);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
